// extracted by mini-css-extract-plugin
module.exports = {"swiper-slide":"logoCarousel_swiper-slide__rQv_T"};